import _ from 'lodash';

import ConversationMessageAttachment from 'scripts/domain/models/conversation_message_attachment.js';
import createEnum from 'scripts/lib/create_enum';
import createModel, { prop } from './lib/create_model';
import redactAttachment from './attachment_redact';

export const ChatMessageStatusCode = createEnum('FAILED', 'NEW', 'SENT');
export const ChatPlatform = createEnum('ANDROID', 'IOS', 'WEB');
export const OutgoingChatOperation = createEnum('END_CHAT', 'SEND_CHAT_MESSAGE', 'REQUEST_CREDIT_CARD');

export const ChatMessageStatus = createModel({
  modelName: 'ChatMessageStatus',

  properties: {
    errorCode: String,
    value: prop().oneOf(..._.keys(ChatMessageStatusCode)),
  },
});

const ChatMessage = createModel({
  modelName: 'ChatMessage',

  properties: {
    attachments: [ConversationMessageAttachment],
    deviceManufacturer: prop(String),
    deviceModel: prop(String),
    messageId: prop(String),
    os: prop(String),
    osVersion: prop(String),
    participantId: prop(String),
    platform: prop()
      .oneOf(..._.keys(ChatPlatform))
      .default(ChatPlatform.WEB),
    sdkVersion: prop(String),
    sentAt: prop(String),
    sessionId: prop(String),
    sessionItemId: prop(String),
    status: prop(ChatMessageStatus),
    text: prop(String),
  },

  getStatus() {
    return (this.status && this.status.value) || ChatMessageStatusCode.NEW;
  },

  hasErrorStatus() {
    return hasErrorStatus(this.getStatus());
  },

  getErrorCode() {
    return (this.status && this.status.errorCode) || '';
  },

  getErrorMessage() {
    let errorCode = this.getErrorCode();
    if (errorCode === ErrorCodes.CANNOT_INITIATE_SESSION) {
      return 'Could not send message because chat was already ended.';
    } else if (errorCode === ErrorCodes.NO_ACTIVE_CONVERSATION) {
      return 'Could not send message because conversation was closed.';
    }

    return '';
  },

  isMobileSdk() {
    return this.platform !== ChatPlatform.WEB;
  },

  redactAttachment(id) {
    redactAttachment(this.attachments, id);
  },

  statics: {
    MAX_MESSAGE_SIZE: 2048,
  },
});

export const ErrorCodes = {
  CANNOT_INITIATE_SESSION: 'CANNOT_INITIATE_SESSION',
  NO_ACTIVE_CONVERSATION: 'NO_ACTIVE_CONVERSATION',
};

export function hasErrorStatus(status) {
  return status === ChatMessageStatusCode.FAILED;
}

export default ChatMessage;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/chat_message.js